import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }) => ({
  dropzone: {
    borderRadius: 12,
    border: '1px solid #E8ECEE',
    background: '#fff',
    padding: 16,
    transition:
      'border-color 0.15s ease-in-out, background-color 0.15s ease-in-out'
  },
  // Nothing to show yet, so the whole tile reads as a drop target.
  dropzoneEmpty: {
    border: '1px dashed #C5CDD5',
    background: '#F8F9FA',
    cursor: 'pointer',
    '&:hover': {
      borderColor: palette.primary.main,
      background: '#F3F8FF'
    }
  },
  dropzoneActive: {
    borderColor: palette.primary.main,
    borderStyle: 'dashed',
    background: '#F3F8FF'
  },
  dropzoneDisabled: {
    opacity: 0.6,
    pointerEvents: 'none'
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 4,
    padding: '12px 0'
  },
  filled: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  },
  thumb: {
    width: 88,
    height: 64,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    border: '1px solid #E8ECEE',
    background: '#fff',
    overflow: 'hidden'
  },
  thumbImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain'
  },
  filledText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    minWidth: 0
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 8
  },
  // The tile is small, so the actions sit tighter than a default SButton.
  actionButton: {
    padding: '3px 12px',
    minHeight: 28,
    fontSize: 13,
    lineHeight: 1.5
  },
  actionTextButton: {
    padding: '3px 8px',
    minHeight: 28,
    fontSize: 13,
    lineHeight: 1.5
  }
}));
